import { render, staticRenderFns } from "./clientPropositionsBlock.vue?vue&type=template&id=6c516092&"
import script from "./clientPropositionsBlock.vue?vue&type=script&lang=js&"
export * from "./clientPropositionsBlock.vue?vue&type=script&lang=js&"
import style0 from "./clientPropositionsBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports